<app-header-user></app-header-user>



<div class="ptb-70">
  <div class="container">

    <!-- Error info box, în același stil ca biletele / programările -->
    <div class="single-events-box mb-40 error-box">
      <div class="events-box">
        <div class="events-image d-none d-md-block">
          <div class="image">
            <i class="bx bx-error-alt pIcon"></i>
          </div>
        </div>

        <div class="events-content">
          <div class="content">
            <h5>Pagina nu a fost găsită sau a apărut o eroare</h5>
            <p>
              Link-ul accesat este incorect, pagina a fost mutată sau a apărut o eroare neașteptată.
            </p>
            <p class="mb-0">
              Puteți reveni la pagina principală sau în contul dumneavoastră folosind butoanele de mai jos.
            </p>
          </div>
        </div>

        <div class="events-date">
          <div class="date">
            <h3>Eroare 404</h3>
            <i class="bx bx-sad"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Butoane acțiune, cu default-btn (verde) -->
    <div class="row justify-content-center">
      <div class="col-md-6 text-center">
        <button
          class="default-btn small-button mb-2"
          routerLink="/">
          <i class="bx bx-home"></i>
          <span>Înapoi la pagina principală</span>
        </button>

        <button
          class="default-btn small-button ms-md-3"
          routerLink="/contul-meu">
          <i class="bx bx-user-circle"></i>
          <span>Mergi la contul meu</span>
        </button>
      </div>
    </div>

  </div>
</div>
